import {createElement, Component, PropTypes} from 'rlink-react';
import {connect} from 'react-redux';
import navTo from 'rlink-router/actions/navTo';
import externalNavTo from 'rlink-router/actions/externalNavTo';
import openModal from 'rlink-router/actions/openModal';
import openFlyout from 'rlink-router/actions/openFlyout';
import BuildContext from 'rlink-router/BuildContext';

class Select extends Component {
  render () {
    let {onActivate, onChange, choices, value: selectedValue, ...props} = this.props;
    let isSelectedValue = typeof selectedValue === 'function'
      ? selectedValue
      : value => selectedValue === value;
    return <select
      value={choices.findIndex(({value, selected}) => selected || isSelectedValue(value))}
      onChange={ev => {
        let onChangekHandlerPreventedDefault = false;
        if (onChange) {
          onChange(ev);
          onChangekHandlerPreventedDefault = ev.defaultPrevented;
        }
        ev.preventDefault();
        if (onActivate && !onChangekHandlerPreventedDefault) {
          onActivate(this.context.buildContext, choices[Number(ev.target.value)].value);
        }
      }}
      {...props}>{choices.map(({label, value}, idx) => <option
        key={idx} value={idx}>{label}</option>)}</select>;
  }
}


Select.propTypes = {
  autofocus: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  choices: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node,
    value: PropTypes.any,
    selected: PropTypes.bool,
  })),
  value: PropTypes.any,
  onActivate: PropTypes.func,
  onChange: PropTypes.func,
};


Select.contextTypes = {
  buildContext: PropTypes.instanceOf(BuildContext),
};


const NavSelect = connect(
  ({routing}, {choices}) => {
    return {
      choices: choices.map(({label, href, selected}) => ({label, value: href, selected})),
    };
  },
  dispatch => ({
    onActivate: (buildContext, value) => {
      if (typeof value === 'string') {
        dispatch(externalNavTo({url: value}));
      } else {
        if (value.modal) {
          dispatch(openModal({buildContext, ...value}));
        } else if (value.flyout) {
          dispatch(openFlyout({buildContext, ...value}));
        } else {
          dispatch(navTo(buildContext, value));
        }
      }
    },
  })
)(Select);


NavSelect.propTypes = {
  choices: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node,
    selected: PropTypes.bool,
    href: PropTypes.oneOf([
      PropTypes.shape({
        view: PropTypes.string.isRequired,
        params: PropTypes.objectOf(PropTypes.string),
        transition: PropTypes.string,
        returnTransition: PropTypes.string,
        scrollTo: PropTypes.shape({
          top: PropTypes.number,
          left: PropTypes.number,
        }),
        modal: PropTypes.boolean,
        flyout: PropTypes.boolean,
      }),
      PropTypes.string,
    ]),
  })),
  ...Select.propTypes,
};
export default NavSelect;



// WEBPACK FOOTER //
// ./lib/rlink-router/NavSelect.jsx